import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  const valores = [
    { emoji: "❤️", title: "Atendimento Humanizado", desc: "Cada paciente é única e recebe atenção individualizada" },
    { emoji: "🔒", title: "Ética e Sigilo", desc: "Respeito absoluto à sua privacidade e confiança" },
    { emoji: "⭐", title: "Excelência Técnica", desc: "Baseado nas mais recentes evidências científicas" },
    { emoji: "🫂", title: "Sem Pressa", desc: "Consultas com tempo adequado para escuta ativa" }
  ];

  return (
    <section id="sobre" className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row gap-12 items-center">
          {/* Foto */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="md:w-1/2"
          >
            <div className="relative">
              <div className="absolute -inset-4 bg-primary/10 rounded-2xl blur-2xl"></div>
              <img
                src="/assets/images/IMG_1104.jpg"
                alt="Dra. Fernanda Palhares em atendimento"
                className="relative w-full rounded-2xl shadow-2xl object-cover"
                onError={(e) => {
                  console.error("Erro ao carregar imagem:", e.target.src);
                  e.target.src = "https://via.placeholder.com/600x600?text=Dra.+Fernanda+Atendimento";
                }}
              />
            </div>
          </motion.div>

          {/* Texto */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="md:w-1/2"
          >
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-textDark mb-6">
              Conheça a<span className="text-primary"> Dra. Fernanda Palhares</span>
            </h2>
            <p className="text-textLight leading-relaxed mb-4">
              Sou ginecologista e obstetra, e minha missão é ajudar mulheres a se reconectarem 
              com seu corpo, sua saúde íntima e seu equilíbrio hormonal em todas as fases da vida.
            </p>
            <p className="text-textLight leading-relaxed mb-4">
              Acredito que cada mulher é única. Por isso, cada consulta é conduzida com 
              escuta atenta, olhar individualizado e explicações claras. Meu foco é entender 
              sua história, suas queixas e construir, junto com você, um plano de cuidado 
              que faça sentido para o seu momento.
            </p>
            <p className="text-textLight leading-relaxed mb-6">
              Atuo com ênfase em saúde íntima e reposição hormonal, buscando não apenas 
              tratar sintomas, mas melhorar sua qualidade de vida, autoestima e bem-estar.
            </p>
            <p className="text-primary font-semibold mb-8">
              CRM 3443 • RQE 2611 (Ginecologia/Obstetrícia)
            </p>

            {/* Cards de valores */}
            <div className="grid grid-cols-2 gap-4">
              {valores.map((valor, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-secondary/20 rounded-xl p-4 text-center hover:bg-secondary/30 transition"
                >
                  <div className="text-3xl mb-2">{valor.emoji}</div>
                  <h3 className="font-bold text-textDark text-sm mb-1">{valor.title}</h3>
                  <p className="text-textLight text-xs">{valor.desc}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;